import {
  Leaf, Sprout, TreePine, Sun, Wind, Droplets, Waves, CloudRain, Mountain,
  Recycle, Trash, Trash2, Globe, FlameKindling, Zap, Bug, Bird, Dog, Cat, Fish,
  Users, Heart, HeartPulse, HandHeart, Building2, School, Stethoscope, Baby, UserCheck,
  Bike, Car, Calendar, Camera, Mic, Music, Coffee, Package, ShoppingBag,
  BookOpen, Home, Star, MapPin, Flag, Flower2, TreeDeciduous,
  GraduationCap, Lightbulb,
} from 'lucide-react';

export const ICON_SET = [
  { name: 'Leaf', component: Leaf },
  { name: 'Sprout', component: Sprout },
  { name: 'TreePine', component: TreePine },
  { name: 'TreeDeciduous', component: TreeDeciduous },
  { name: 'Flower2', component: Flower2 },
  { name: 'Sun', component: Sun },
  { name: 'Wind', component: Wind },
  { name: 'Droplets', component: Droplets },
  { name: 'Waves', component: Waves },
  { name: 'CloudRain', component: CloudRain },
  { name: 'Mountain', component: Mountain },
  { name: 'Recycle', component: Recycle },
  { name: 'Trash', component: Trash },
  { name: 'Globe', component: Globe },
  { name: 'FlameKindling', component: FlameKindling },
  { name: 'Zap', component: Zap },
  { name: 'Bug', component: Bug },
  { name: 'Bird', component: Bird },
  { name: 'Fish', component: Fish },
  { name: 'Dog', component: Dog },
  { name: 'Cat', component: Cat },
  { name: 'Users', component: Users },
  { name: 'Heart', component: Heart },
  { name: 'HandHeart', component: HandHeart },
  { name: 'Building2', component: Building2 },
  { name: 'School', component: School },
  { name: 'Stethoscope', component: Stethoscope },
  { name: 'Baby', component: Baby },
  { name: 'UserCheck', component: UserCheck },
  { name: 'Bike', component: Bike },
  { name: 'Car', component: Car },
  { name: 'Calendar', component: Calendar },
  { name: 'Camera', component: Camera },
  { name: 'Mic', component: Mic },
  { name: 'Music', component: Music },
  { name: 'Coffee', component: Coffee },
  { name: 'Package', component: Package },
  { name: 'ShoppingBag', component: ShoppingBag },
  { name: 'BookOpen', component: BookOpen },
  { name: 'Home', component: Home },
  { name: 'Star', component: Star },
  { name: 'MapPin', component: MapPin },
  { name: 'Flag', component: Flag },
  { name: 'Trash2', component: Trash2 },
  { name: 'HeartPulse', component: HeartPulse },
  { name: 'GraduationCap', component: GraduationCap },
  { name: 'Lightbulb', component: Lightbulb },
];

export const isImageUrl = (v) =>
  typeof v === 'string' && (v.startsWith('http') || v.startsWith('/api/files/'));

export const InterestIcon = ({ icon, size = 16, className = '' }) => {
  if (isImageUrl(icon)) {
    return (
      <img
        src={icon}
        alt="icon"
        style={{ width: size, height: size }}
        className={`object-contain flex-shrink-0 ${className}`}
      />
    );
  }
  const found = ICON_SET.find((i) => i.name === icon);
  if (found) {
    const Comp = found.component;
    return <Comp size={size} className={className} />;
  }
  return <span className={className} style={{ fontSize: size }}>{icon}</span>;
};
